
import moment from "moment";
import { MdOutlineClose } from "react-icons/md";
const ViewHistoryModal = ({
  isOpen,
  onClose,
  heading,
  data = [],
  isNotesData = false, isApiResData = false,
  data2,

}) => {
  if (!isOpen) return null;

  console.log(data2)

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 overflow-y-auto'>
      <div className='w-11/12 lg:w-full max-w-xl max-h-[85vh] p-6 bg-white rounded-lg shadow-md flex flex-col my-auto overflow-hidden'>
        <div className='flex justify-between items-center mb-4 flex-shrink-0'>
          <p className='font-bold text-black text-lg'>
            {heading}
          </p>
          <div className='bg-[#15A14A26] rounded-full flex justify-center items-center h-7 w-7 text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
            <MdOutlineClose
              size={20}
              className=' cursor-pointer'
              onClick={onClose}
              title='Close'
            />
          </div>
        </div>

        <div className="overflow-y-auto flex-1 pr-1 space-y-4 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-full">
          {
            isApiResData && (
              <div className="bg-white">
                {data.length > 0 ? (
                  <div className="space-y-4">
                    {data.map((item, index) => (
                      <div
                        key={item._id || index}
                        className="relative bg-white border-l-4 border-green-500 rounded-xl shadow shadow-gray-300 p-4"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <div>
                            <p className="font-medium text-gray-700">
                              Action by:{" "}
                              <span className="text-blue-600 font-semibold">
                                {item.rejectedBy?.userName}
                              </span>{" "}
                              ({item.rejectedBy?.employeeId})
                            </p>
                            <p className=" text-gray-500">
                              {moment(item.rejectionDate).format("YYYY-MM-DD HH:mm:ss")}
                            </p>
                          </div>
                          <span className="bg-red-100 text-red-600 text-xs font-medium px-3 py-1 rounded-full capitalize">
                            {item?.status}
                          </span>
                        </div>

                        <div
                          className="text-sm text-gray-800 text-start"
                          dangerouslySetInnerHTML={{ __html: item.reason }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 text-center">No history available.</p>
                )}
              </div>
            )
          }

          {
            isNotesData && (
              <div className="bg-white space-y-4">
                {data2?.attachment && (
                  <div className="relative bg-white border-l-4 border-green-500 rounded-xl shadow shadow-gray-300 p-4">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <p className="font-medium text-gray-700">
                          Proof uploaded by:{" "}
                          <span className="text-blue-600 font-semibold">
                            {data2?.verifiedBy?.userName || "Admin"}
                          </span>{" "}
                          {data2?.verifiedBy?.employeeId ? `(${data2.verifiedBy.employeeId})` : ""}
                        </p>
                        <p className="text-gray-500 text-xs">
                          {data2?.updatedAt ? moment(data2.updatedAt).format("YYYY-MM-DD HH:mm:ss") : ""}
                        </p>
                      </div>
                      <span className="bg-green-100 text-green-700 text-xs font-medium px-3 py-1 rounded-full capitalize">
                        {data2?.requestStatus || "Approved"}
                      </span>
                    </div>

                    <div className="flex flex-col items-center justify-center bg-gray-50 rounded-lg p-3 border border-gray-200 overflow-hidden">
                      <p className="text-xs font-medium text-gray-500 mb-2 self-start">Redemption Proof Image:</p>
                      <div className="flex items-center justify-center w-full max-h-64 sm:max-h-72 overflow-hidden rounded bg-white p-1 border border-gray-150">
                        <img
                          src={data2.attachment}
                          alt="Redemption Proof"
                          className="max-h-60 sm:max-h-64 max-w-full w-auto object-contain rounded cursor-pointer hover:opacity-90 transition-opacity"
                          onClick={() => window.open(data2.attachment, "_blank")}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => window.open(data2.attachment, "_blank")}
                        className="text-xs text-blue-600 hover:text-blue-800 underline font-medium mt-3"
                      >
                        View Full Size in New Tab
                      </button>
                    </div>
                  </div>
                )}

                {data2?.notes && data2.notes.length > 0 && (
                  <div className="space-y-4">
                    {data2.notes.map((item, index) => (
                      <div
                        key={item._id || index}
                        className="relative bg-white border-l-4 border-green-500 rounded-xl shadow shadow-gray-300 p-4"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <div>
                            <p className="font-medium text-gray-700">
                              Action by:{" "}
                              <span className="text-blue-600 font-semibold">
                                {data2?.verifiedBy?.userName}
                              </span>{" "}
                              ({data2?.verifiedBy?.employeeId})
                            </p>
                            <p className=" text-gray-500">
                              {moment(data2?.updatedAt).format("YYYY-MM-DD HH:mm:ss")}
                            </p>
                          </div>
                          <span className="bg-red-100 text-red-600 text-xs font-medium px-3 py-1 rounded-full capitalize">
                            {data2?.requestStatus}
                          </span>
                        </div>

                        <div
                          className="text-sm text-gray-800 text-start"
                          dangerouslySetInnerHTML={{ __html: item }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {!data2?.attachment && (!data2?.notes || data2.notes.length === 0) && (
                  <p className="text-gray-500 text-center py-4">No history or details available.</p>
                )}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ViewHistoryModal;